import { render, staticRenderFns } from "./Unarchive-Dialog.vue?vue&type=template&id=34f7dda9"
import script from "./Unarchive-Dialog.vue?vue&type=script&lang=js"
export * from "./Unarchive-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports